export default {
  data() {
    return {};
  },
  methods: {
    iconFunctions(u) {
      if (u === "M1") {
        let k = {
          title: "Maintenance Assurance",
          icon: "home"
        };
        return k;
      }
      if (u === "M2") {
        let k = {
          title: "Maintenance Strategy",
          icon: "app_registration"
        };
        return k;
      }
      if (u === "M3") {
        let k = {
          title: "Maintenance Plan",
          icon: "app_registration"
        };
        return k;
      }
      if (u === "M3") {
        let k = {
          title: "Maintenance Call",
          icon: "app_registration"
        };
        return k;
      }
    }
  }
};
